import * as React from "react";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import { Container, Button, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    // faPencilAlt, faTrash, faPlus,
    faPlus,
    faPencilAlt,
    faTrash
} from "@fortawesome/free-solid-svg-icons";

import "./userRoles.css";
import i18n from "../i18n";

import UserRoleEdit from "./userRoles-edit";
import { getAsync, postAsync } from "../utils/net";
import { ToastsStore } from "react-toasts";

// import { Date } from "core-js";

export interface UserRolesProps { }
export interface UserRolesState {
    userRoles: any[];
    quickfind: string;
    typeValues: any[];
    marketValues: any[];
    loading: boolean;
    selectedItem: any;
    showEdit: boolean;
    showDelete: boolean;
    isNew: boolean;
    showAddNewUserDialog: boolean;
}

export class UserRoles extends React.Component<
    UserRolesProps,
    UserRolesState
    > {
    private filterMethod = (filter: any, row: any) =>
        new RegExp(filter.value, "i").test(String(row[filter.id]));

    private columns: Column[] = [
        {
            Header: i18n.UserRoles.Table.UserEmailAddress,
            accessor: "upn"
        },
        {
            Header: i18n.UserRoles.Table.UserRoleType,
            accessor: "role"
        },
        {
            Header: i18n.UserRoles.Table.AssignedBy,
            accessor: "assignedBy"
        },
        {
            Header: i18n.UserRoles.Table.AssignedAt,
            filterable: false,
            Cell: row => (
                this.formatDate(row.original._ts)
            )
        },
        // {
        //     Header: i18n.UserRoles.Table.AssignedAt,
        //     accessor: "_ts",

        // },
        {
            Header: "",
            filterable: false,
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => this.onEdit(row.original)}
                >
                    <FontAwesomeIcon icon={faPencilAlt} />
                </Button>
            )
        },
        {
            Header: "",
            filterable: false,
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="danger"
                    onClick={() => this.onDelete(row.original)}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            )
        }

    ];
    constructor(props: UserRolesProps) {
        super(props);
        this.state = {
            selectedItem: null,
            loading: false,
            showDelete: false,
            showEdit: false,
            isNew: false,
            showAddNewUserDialog: false,
            userRoles: [],
            typeValues: [],
            marketValues: [],
            quickfind: "",
        };
    }
    componentWillMount() {
        this.loadUserRoles();
    }

    render() {
        return (
            <Container fluid={true} className="scenarios-page page">
                <h1 className="page-header">{i18n.UserRoles.Title}</h1>
                <p>
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.onAddNewUser()}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                        &nbsp; {i18n.UserRoles.AddUser}
                    </Button>&nbsp;
                  </p>
                <p>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">🔍</InputGroupAddon>
                        <Input placeholder="quick find" onChange={e => this.onQuickFind(e)} />
                    </InputGroup>
                </p>
                <ReactTable
                    noDataText={this.state.loading ? "Loading" : "No items found"}
                    data={this.list}
                    filterable={true}
                    columns={this.columns}
                    defaultFilterMethod={this.filterMethod}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
                {
                    <UserRoleEdit
                        item={this.state.selectedItem}
                        isOpen={this.state.showEdit}
                        isNew={this.state.isNew}
                        onCancel={() => this.onCancelEdit()}
                        onSave={model => this.onSave(model)}
                    />}
            </Container>
        );
    }

    private formatDate(dateUnixNumber: number) {

        var d = new Date(dateUnixNumber * 1000);

        return d.toLocaleString("en-US");
        // tslint:disable-next-line:max-line-length
        // return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    }

    private async loadUserRoles() {
        this.setState({ loading: true });
        const reply = await getAsync("/api/UserManagement");
        const payload = await reply.json();

        this.setState({
            userRoles: payload,
            loading: false
        });
    }

    private onEdit(item: any) {
        this.setState({ selectedItem: item, showEdit: true });
    }

    private onCancelEdit() {
        this.setState({ showEdit: false, selectedItem: null });
    }

    private async onSave(item: any) {

        if (!item.role || item.role.length === 0) {
            return;
        }

        const userRole = item.role[0];
        try {
            const reply = await postAsync(`/api/UserManagement/${item.upn}`, userRole, "PUT");
            if (reply.ok) {
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadUserRoles();
                ToastsStore.success(i18n.UserRoles.SaveOk);

            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with the status code error.
            // thus we avoid showing another modal window here and provide instead custom error message in a toast
            ToastsStore.error(i18n.UserRoles.SaveFailure);
        }
    }

    private async onDelete(item: any) {
        if (!confirm(i18n.Global.Delete.Confirm)) {
            return;
        }

        try {
            const reply = await postAsync(`/api/UserManagement/${item.upn}`, "", "DELETE");
            if (reply.ok) {
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadUserRoles();
                ToastsStore.success(i18n.UserRoles.DeleteOk);
            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with the status code error.
            // thus we avoid showing another modal window here and provide instead custom error message in a toast
            ToastsStore.error(i18n.UserRoles.DeleteFailure);
        }
    }

    private onAddNewUser() {
        this.setState({
            showEdit: true, selectedItem: {
                "upn": "",
                "role": "",
            }, isNew: true
        });
    }

    private onQuickFind(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            quickfind: e.target.value,
        })
    }

    private get list() {
        return this.state.userRoles
            .filter(this.state.quickfind
                ? item => this.columns.some(col => this.filterMethod(
                    { id: col.accessor, value: this.state.quickfind }, item)
                )
                : () => true)
    }
}



// WEBPACK FOOTER //
// ./src/userRoles/userRoles.tsx